import React, { useContext } from 'react'
import { Header } from 'goustouicomponents/dist/Header'
import { store } from '../../store'
import { getIsAuthenticated } from '../../selectors/auth'

const HeaderContainer = () => {
  const { state } = useContext(store)
  const isAuthenticated = getIsAuthenticated(state) || false

  return <Header isAuthenticated={isAuthenticated} hasDataTracking />
}

export { HeaderContainer }
